import { SOURCE_CONTEXT_KEY, SOURCE_CONTEXT_PAYLOAD } from '../../consts/navigation';
import { getWindow } from '../../utils/browser';
import { addSearchParamsInRoute } from '../addSearchParamsInRoute';
import type { ProcessURLMiddleware } from '../useRouter';

const MODULES_THAT_CAN_BE_EMBEDDED = ['automations', 'pipelines'];

export const getPersistSourceInRouteMiddleware: ProcessURLMiddleware = (route, options) => {
  const { persistSourceInfo } = options || {};

  const shouldPersistSourceInfo =
    // 3rd because zero is "", first is "p", second is projectId
    persistSourceInfo ?? MODULES_THAT_CAN_BE_EMBEDDED.includes(route.split('/')[3]);

  if (shouldPersistSourceInfo) {
    const searchParams = new URLSearchParams(getWindow()?.location.search);
    const source = searchParams.get(SOURCE_CONTEXT_KEY);
    const sourcePayload = searchParams.get(SOURCE_CONTEXT_PAYLOAD);
    if (source) {
      return addSearchParamsInRoute(route, {
        [SOURCE_CONTEXT_KEY]: source,
        [SOURCE_CONTEXT_PAYLOAD]: sourcePayload,
      });
    }
  }

  return route;
};
